import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { CustomRepoSetupField, validateRepoSetup } from './CustomRepoSetupField';

export const CustomRepoSetupFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'CustomRepoSetupField',
    component: CustomRepoSetupField,
    validation: validateRepoSetup,
  }),
);
